<h2 mat-dialog-title>
  {{ 'PLATFORM_DISRUPTIONS.TITLE' | translate }}
</h2>

<div mat-dialog-content>
  <form [formGroup]="form" (submit)="addDisruption()" class="form-container">
    <mat-form-field class="input-message-en">
      <input matInput formControlName="messageEn" />
      <mat-label>{{
        'PLATFORM_DISRUPTIONS.COLUMNS.messageEn' | translate
      }}</mat-label>
    </mat-form-field>

    <mat-form-field class="input-message-es">
      <input matInput formControlName="messageEs" />
      <mat-label>{{
        'PLATFORM_DISRUPTIONS.COLUMNS.messageEs' | translate
      }}</mat-label>
    </mat-form-field>

    <mat-form-field class="input-message-fr">
      <input matInput formControlName="messageFr" />
      <mat-label>{{
        'PLATFORM_DISRUPTIONS.COLUMNS.messageFr' | translate
      }}</mat-label>
    </mat-form-field>

    <div class="save-button">
      <button
        mat-raised-button
        color="primary"
        type="submit"
        [disabled]="!form.valid"
        [ngClass]="{ disabled: !form.valid }"
      >
        {{ 'GENERAL.ADD' | translate }}
      </button>
    </div>
  </form>

  @if (displayLoader) {
    <div class="spinner flex flex-align-center--center">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  } @else {
    <div class="dialog-content">
      <table mat-table [dataSource]="disruptions">
        @for (column of displayedColumns; track $index) {
          <ng-container [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'PLATFORM_DISRUPTIONS.COLUMNS.' + column | translate }}
            </th>

            @if (column === 'startDate' || column === 'endDate') {
              <td mat-cell *matCellDef="let row">
                @if (column === 'endDate' && row[column] == null) {
                  <button
                    mat-raised-button
                    color="warn"
                    type="button"
                    (click)="closeDisruption.emit(row.id)"
                  >
                    {{
                      'PLATFORM_DISRUPTIONS.COLUMNS.CLOSE_BUTTON' | translate
                    }}
                  </button>
                } @else {
                  {{ row[column] | localizedDateTime }}
                }
              </td>
            } @else {
              <td mat-cell *matCellDef="let row">
                {{ row[column] }}
              </td>
            }
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button type="button" (click)="closeDialog.emit()">
    {{ 'GENERAL.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
